import { useId } from 'react';
import Datepicker from './Datepicker';

const FormDateRangePicker = ({
  date,
  onSelect,
  single = false,
  shortcuts = false,
  label,
  placeholder = 'Pilih tanggal',
  containerClassName = '',
  inputClassName = '',
  disabled = false,
  isDisabled = false,
  id,
  maxDate = new Date(),
  ...props
}) => {
  const generatedId = useId();
  const controlId = id || generatedId;
  const value = { startDate: date?.startDate || null, endDate: date?.endDate || null };
  return (
    <div className={`w-full min-w-0 space-y-2 ${containerClassName}`}>
      {label && (
        <label htmlFor={controlId} className='block text-sm font-medium text-gray-700'>
          {label}
        </label>
      )}
      <Datepicker
        {...props}
        id={controlId}
        value={value}
        onChange={onSelect}
        disabled={disabled || isDisabled}
        placeholder={placeholder}
        showShortcuts={shortcuts}
        asSingle={single}
        useRange={!single}
        maxDate={maxDate}
        containerClassName='w-full'
        inputClassName={inputClassName}
      />
    </div>
  );
};

export default FormDateRangePicker;
